<ng-container *transloco="let t; read: 'call-list-communication-workflow-config-editor'">
  <form [formGroup]="form">
    <div class="grid-nogutter">
      <div class="grid-nogutter p-fluid">
        <!-- Call Flow -->
        <div class="field mt-1">
          <div class="call-list__selector">
            <span class="font-bold">{{ t('callFlowLabel') }}</span>
            <p-selectButton [allowEmpty]="false" [formControl]="callFlowType" [options]="callFlowTypeOptions">
              <ng-template let-item pTemplate="item">{{ t(item.label) }}</ng-template>
            </p-selectButton>
          </div>

          <p-messages severity="info">
            <ng-template pTemplate>
              <app-form-field-help [control]="callFlowType">
                <ng-container form-field-help-hint>
                  {{ t(callFlowType.value === 'standard' ? 'callFlowStandardHelpText' : 'callFlowAdvancedHelpText') }}
                </ng-container>
              </app-form-field-help>
            </ng-template>
          </p-messages>

          <!-- Communication Workflow Autocomplete -->
          <div *ngIf="isCallFlowTypeAdvanced" class="field mt-3">
            <span class="p-float-label">
              <span>{{ t('callFlowCommunicationWorkflowLabel') }}</span>
              <app-communication-workflow-autocomplete
                [formControl]="communicationWorkflowId"
              ></app-communication-workflow-autocomplete>
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
